"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const checkbox_1 = require("components/cosmos/checkbox");
const customTable_1 = require("components/customTable");
const infinityScrollPagination_1 = require("components/infinityScrollPagination");
const loader_1 = require("components/loader");
const translate_1 = require("components/translate");
const constants_1 = require("configs/routes/constants");
const class_1 = require("modules/app/services/datahub/class");
const content_1 = require("modules/content");
const moduleService_1 = require("modules/content/moduleService");
const ui_1 = require("modules/ui");
const visibilityStatus_1 = __importDefault(require("./visibilityStatus"));
const ClassService_1 = __importDefault(require("../ClassService"));
const modules_module_scss_1 = __importDefault(require("./modules.module.scss"));
const CHECK_BOX_ID_PREFIX = 'moduleChecklist';
const INITIAL_PAGED_CONTENT = {
    content: [],
    numberOfElements: 0,
    page: 0,
    totalElements: 0,
    totalPages: 0
};
const Modules = ({ history, classId, isExtraModule = false }) => {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [pagedContent, setPagedContent] = (0, react_1.useState)(INITIAL_PAGED_CONTENT);
    const [selectedModuleIds, setSelectedModuleIds] = (0, react_1.useState)([]);
    const { elementToObserverRef, pageNumber, hasNextPage } = (0, infinityScrollPagination_1.useInfinityScrollPagination)({
        totalPages: pagedContent.totalPages
    });
    (0, react_1.useEffect)(() => {
        const getClassModules = async () => {
            setIsLoading(true);
            const classModules = await moduleService_1.ModuleService.getClassModules(classId, isExtraModule);
            const classModulesIds = classModules.map((classModule) => classModule.id);
            setSelectedModuleIds(classModulesIds);
            setIsLoading(false);
        };
        getClassModules();
    }, [classId, isExtraModule]);
    (0, react_1.useEffect)(() => {
        const getModules = async (pageNumber) => {
            setIsLoading(true);
            const modules = await moduleService_1.ModuleService.getModules({
                isExtraModule,
                page: pageNumber
            });
            setPagedContent((state) => ({
                ...modules,
                ...(state && { content: [...state.content, ...modules.content] })
            }));
            setIsLoading(false);
        };
        if (hasNextPage) {
            getModules(pageNumber);
        }
    }, [isExtraModule, pageNumber, hasNextPage]);
    const redirectToClassListPage = () => history.push(constants_1.ROUTES.CLASS.LIST);
    const handleSelect = ({ target }) => {
        const moduleId = target.value;
        let newSelectedModuleIds = [...selectedModuleIds, moduleId];
        let classCategory = class_1.ClassCategory.SelectClassModule;
        if (!target.checked) {
            newSelectedModuleIds = newSelectedModuleIds.filter((selectedModuleId) => selectedModuleId !== moduleId);
            classCategory = class_1.ClassCategory.UnselectAllClassModule;
        }
        setSelectedModuleIds(newSelectedModuleIds);
        class_1.DatahubClassService.sendSelectClassModuleEvent({
            category: classCategory,
            classId
        });
    };
    const handleSave = async () => {
        try {
            await ClassService_1.default.updateClassModules({
                classId,
                isExtraModule,
                selectedModuleIds
            });
            ui_1.UiService.setAlertSuccess('done');
            class_1.DatahubClassService.sendSaveClassModuleEvent({ isExtraModule, classId });
            redirectToClassListPage();
        }
        catch (error) {
            ui_1.UiService.handleError(error);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(content_1.ContentBasePage, { className: modules_module_scss_1.default.container, "data-test": "class-modules-container", children: [(0, jsx_runtime_1.jsx)("p", { className: "_font-weight-bold _line-height-lg", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.list_modules.title" }) }), (0, jsx_runtime_1.jsx)("p", { className: "_mb-7", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.list_modules.description" }) }), (0, jsx_runtime_1.jsxs)(customTable_1.CustomTable, { className: modules_module_scss_1.default.tableContent, position: "sticky", children: [(0, jsx_runtime_1.jsx)(customTable_1.CustomTable.Head, { children: (0, jsx_runtime_1.jsxs)(customTable_1.CustomTable.Row, { children: [(0, jsx_runtime_1.jsx)(customTable_1.CustomTable.Col, { variation: "headerColumn", scope: "col", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: `class_manager.class_editor.list_modules.${isExtraModule ? 'additional_modules' : 'main_modules'}` }) }), (0, jsx_runtime_1.jsx)(customTable_1.CustomTable.Col, { variation: "headerColumn", scope: "col", children: (0, jsx_runtime_1.jsx)(translate_1.I18n, { label: "class_manager.class_editor.list_modules.visibility" }) })] }) }), (0, jsx_runtime_1.jsxs)(customTable_1.CustomTable.Body, { children: [pagedContent.content.map(({ id: moduleId, name: moduleName }) => {
                                const isSelected = selectedModuleIds.includes(moduleId);
                                return ((0, jsx_runtime_1.jsxs)(customTable_1.CustomTable.Row, { children: [(0, jsx_runtime_1.jsx)(customTable_1.CustomTable.Col, { scope: "row", className: modules_module_scss_1.default.col, children: (0, jsx_runtime_1.jsx)(checkbox_1.Checkbox, { id: `${CHECK_BOX_ID_PREFIX}_${moduleId}`, label: moduleName, className: "_mb-0", checked: isSelected, value: moduleId, onChange: handleSelect }) }), (0, jsx_runtime_1.jsx)(customTable_1.CustomTable.Col, { scope: "row", children: (0, jsx_runtime_1.jsx)(visibilityStatus_1.default, { isVisible: isSelected }) })] }, moduleId));
                            }), (0, jsx_runtime_1.jsx)("tr", { children: (0, jsx_runtime_1.jsx)("td", { ref: elementToObserverRef }) })] })] }), isLoading && (0, jsx_runtime_1.jsx)(loader_1.Loader, { inline: true, mask: true }), pagedContent.content.length > 0 && ((0, jsx_runtime_1.jsx)(content_1.ContentBasePage.Footer, { onSubmitAndReturn: handleSave, cancelHandler: redirectToClassListPage }))] }));
};
exports.default = (0, react_router_dom_1.withRouter)(Modules);
